import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { fetchGroups, fetchGroupCategories, selectGroup, resetCurrentGroup, editMultiGroups, deleteGroup, clearDeleteGroupStatus, resetCategory2Id, editMultiGroupsElegant, fetchGroupsElegant } from '../../actions/products_actions';

import Groups from '../../components/Products/groups';

const groups = reduxForm({
  form: 'groups',
})(Groups);

function mapStateToProps(state) {
  return {
    groups: state.products.groups,
    groupIsLoading: state.products.groupIsLoading,
    groupError: state.products.groupError,
    currentGroup: state.products.currentGroup,
    multiIsEditing: state.products.multiGroupIsEditing,
    multiError: state.products.multiGroupEditError,
    multiEdited: state.products.multiGroupEdited,
    userPermissions: state.auth.userPermissions,
    deletingGroup: state.products.deletingGroup,
    deleteGroupSuccess: state.products.deleteGroupSuccess,
    deleteGroupError: state.products.deleteGroupError,
  };
}

export default connect(mapStateToProps, {
  fetchGroups,
  fetchGroupsElegant,
  fetchGroupCategories,
  selectGroup,
  resetCurrentGroup,
  editMultiGroups,
  editMultiGroupsElegant,
  deleteGroup,
  clearDeleteGroupStatus,
  resetCategory2Id,
})(groups);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/groups.jsx